import CircleIcon from '@mui/icons-material/Circle';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import Stack from '@mui/material/Stack';
import { ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import placeholder from 'assets/svg/scc-website-placeholder.svg';
import getTheme from 'modules/connect-card-widget/utils/getTheme';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import ConnectPointPreview from '../connect-hub/ConnectPointPreview';
import ChatBubblePreview from './ChatBubblePreview';
import PopUpPreview from './PopUpPreview';
import StickyBannerPreview from './StickyBannerPreview';
import StickyButtonPreview from './StickyButtonPreview';
import WebsiteWidgetPreview from './WebsiteWidgetPreview';

const DEFAULT_COLOR = '#2186eb';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    minHeight: 'calc(100vh - 160px)',
    overflow: 'hidden',
    border: '1px solid #e0e0e0',
    borderColor: theme.palette.grey[300],
    backgroundColor: theme.palette.background.default,
  },
}));

const WidgetsPreview = ({
  id,
  data,
  cards,
  pathname,
  onRemoveCard,
  onSort,
  onUpdateConnectCard,
}) => {
  const classes = useStyles();
  const account = useSelector((s) => s.settings.account);

  const renderWebsiteWidget = () => {
    return (
      <WebsiteWidgetPreview
        color={data.primary_color || DEFAULT_COLOR}
        data={data}
        cards={cards}
        onSort={onSort}
        onRemoveCard={onRemoveCard}
        pathname={pathname}
        account={account}
      />
    );
  };

  const renderChatBubble = () => {
    return (
      <ChatBubblePreview
        chat={data.collection_settings.chat}
        color={data.primary_color || DEFAULT_COLOR}
      />
    );
  };

  const renderStickyBanner = () => {
    return (
      <StickyBannerPreview
        banner={data.collection_settings.banner}
        color={data.primary_color || DEFAULT_COLOR}
      />
    );
  };

  const renderPopup = () => {
    return (
      <PopUpPreview
        popup={data.collection_settings.popup}
        color={data.primary_color || DEFAULT_COLOR}
      />
    );
  };

  const renderLandingPage = () => {
    return (
      <ConnectPointPreview
        cards={cards}
        data={data}
        onUpdateConnectCard={onUpdateConnectCard}
      />
    );
  };

  const renderStickyButton = () => {
    return (
      <StickyButtonPreview
        options={data.collection_settings.stickyButton}
        color={data.primary_color || DEFAULT_COLOR}
      />
    );
  };

  return (
    <ThemeProvider
      theme={getTheme({
        primary: data.primary_color,
        text: data.collection_text_color,
      })}
    >
      <ScopedCssBaseline
        sx={{ height: '100%', backgroundColor: 'transparent' }}
      >
        <Switch>
          <Route
            exact
            path={`/connect/widgets/${id}/widgets/landing-page`}
            render={renderLandingPage}
          />
          <Paper variant="outlined" className={classes.root}>
            <Stack
              direction="row"
              spacing={0.5}
              bgcolor="grey.400"
              height="35px"
              alignItems="center"
              px={1}
              fontSize={14}
            >
              <CircleIcon opacity={0.3} fontSize="inherit" />
              <CircleIcon opacity={0.3} fontSize="inherit" />
              <CircleIcon opacity={0.3} fontSize="inherit" />
            </Stack>
            <Switch>
              <Route
                exact
                path={[
                  `/connect/widgets/${id}/design`,
                  `/connect/widgets/${id}/cards`,
                ]}
                render={renderWebsiteWidget}
              />
              <>
                {renderChatBubble()}
                {renderStickyButton()}
                {renderStickyBanner()}
                {renderPopup()}
              </>
            </Switch>
          </Paper>
        </Switch>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
};
export default WidgetsPreview;
